import { Component, Input } from '@angular/core';

@Component({
  selector: 'itfg-d-box',
  templateUrl: './d-box.component.html',
  styleUrls: ['./d-box.component.scss'],
  standalone: false,
})
export class DBoxComponent {
  @Input() title?: string;
  @Input() colSpan: number = 1;
  @Input() rowSpan: number = 1;
}
